import { CarePathIcon } from '@ksyos/design-system';
import classnames from 'classnames';
import { EpisodeCategory } from '@common/enums';
import { Icon } from '../../common';
import { episodeCategoryIconName } from '../../Icons/episodeCategoryIconName';
import styles from './IconHeader.module.css';

export function IconHeader(props: { className?: string; icon: string; title: string }) {
    const episodeCategoryIcon = Object.values(EpisodeCategory).find(
        (episodeCategoryName) => episodeCategoryName === props.icon
    );

    return (
        <div className={classnames(styles.iconHeader, 'layout center', props.className || '')}>
            {episodeCategoryIcon ? (
                <CarePathIcon
                    className={styles.icon}
                    icon={episodeCategoryIconName(episodeCategoryIcon)}
                />
            ) : (
                <Icon
                    className={styles.icon}
                    icon={props.icon}
                />
            )}
            <h3>{props.title}</h3>
        </div>
    );
}
